import { useMemo } from 'react';
import { Form } from 'react-final-form';

import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import { InitialValues } from 'forms/types';
import useNavigatorTracking from 'hooks/useNavigatorTracking';
import Steps from 'hooks/useNavigatorTracking/steps';
import goToNextHealthStep from 'utils/goToNextHealthStep';

import { HEADING } from './contants';
import BloodPressureForm from './form';
import { BloodPressureFormValues } from './form/types';
import { useBloodPressureProfileQuery } from './graphql/BloodPressureProfile';
import { useUpdateBloodPressureProfileMutation } from './graphql/UpdateBloodPressureProfile';
import buildInitialValues from './utils/buildInitialValues';
import buildInput from './utils/buildInput';
import { getValidator } from './utils/validate';

const BloodPressure = () => {
  const trackStepCompleted = useNavigatorTracking(Steps.BloodPressure);
  const { data, loading } = useBloodPressureProfileQuery();
  const initialValues = useMemo(() => buildInitialValues(data), [data]);
  const dateOfBirth = data?.currentUser.dateOfBirth;
  const validate = useMemo(() => getValidator({ dateOfBirth }), [dateOfBirth]);

  const [updateBloodPressureProfile] = useUpdateBloodPressureProfileMutation({
    onCompleted(res) {
      trackStepCompleted();
      goToNextHealthStep(res.updateBloodPressure?.nextStepPath);
    },
  });

  const onSubmit = async (values: BloodPressureFormValues) => {
    await updateBloodPressureProfile({
      variables: {
        input: buildInput(values),
      },
    });
  };

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <NavigatorContent heading={HEADING} title={Steps.BloodPressure}>
      <Form<BloodPressureFormValues, InitialValues<BloodPressureFormValues>>
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        {(formProps) => <BloodPressureForm {...formProps} />}
      </Form>
    </NavigatorContent>
  );
};

export default BloodPressure;
